export const BASE_URL = "https://www.duckarena.com/";
export const LOCAL_HOST = "http://localhost/prof_web/";

export function GET_BASE_URL() {
  if (useDev) {
    return LOCAL_HOST;
  } else {
    return BASE_URL;
  }
}

const useDev = false;